import React from "react";
import { Provider } from "react-redux";
import { createStore, combineReducers } from "redux";
import Sidebar from "./Sidebar";
import SidebarReducer from "../Redux/SidebarReducer";
import AlertReducer from "../Redux/AlertReducer";
import DeleteReducer from "../Redux/DeleteReducer";
import BranchReducer from "../Redux/BranchReducer";
import Head from "./Head";
import Dashboard from "../Page/Dashboard";
import Container from "./Container";
import Alert from "../UI/Alert/Alert";
import TelegramGroup from "../Page/Groups/Telegram/TelegramGroup";
import AddTelegramGroup from "../Page/Groups/Telegram/AddTelegramGroup";
import ShopADSView from "../Page/ShopADS/ShopAdsView";
import ShopAdsAdd from "../Page/ShopADS/ShopAdsAdd";
import ShopAdsEdit from "../Page/ShopADS/ShopAdsEdit";
import OfferAdd from "../Page/Offer/OfferAdd";
import PinPanel from "../Page/Advertising/PinPanel";
import OrdersPanel from "../Page/Orders/OrdersPanel";
import UsersPanel from "../Page/Users/UsersPanel";
import UserDetails from "../Page/Users/UserDetails";
import EmployeesPanel from "../Page/Employees/EmployeesPanel";
import AddEmployee from "../Page/Employees/Add";
import EditEmployee from "../Page/Employees/Edit";
import Panels from "../Page/Panels";
import AddPanel from "../Page/Panels/Add";
import EditPanel from "../Page/Panels/Edit";
import ViewPanel from "../Page/Panels/View";
import TrustedPanels from "../Page/Panels/trusted/index";
import ModalReducer from "../Redux/ModalReducer";
import EditTelegramGroup from "../Page/Groups/Telegram/Edit";
import WhatsappGroups from "../Page/Groups/Whatsapp/WhatsappGroups";
import AddWhatsappGroup from "../Page/Groups/Whatsapp/AddWhatsappGroup";
import EditWhatsappGroup from "../Page/Groups/Whatsapp/Edit";
import Support from "../Page/Support";
import BannerPanel from "../Page/Advertising/BannerPanel";
import Offers from "../Page/Offer/Offers";
import OfferEdit from "../Page/Offer/OfferEdit";
import TopResultPanel from "../Page/Advertising/TopResultPanel";
import SkypeGroup from "../Page/Groups/Skype/SkypeGroup";
import AddSkypeGroup from "../Page/Groups/Skype/AddSkypeGroup";
import EditSkypeGroup from "../Page/Groups/Skype/Edit";
import SupportChat from "../Page/SupportChat";
import EditUser from "../Page/Users/Edit";
import EditPinPanel from "../Page/Advertising/pin-edit";
import EditBannerPanel from "../Page/Advertising/banner-edit";
import TicketPanel from "../Page/Advertising/TicketPanel";
import EditTicketPanel from "../Page/Advertising/ticket-edit";
import AddUser from "../Page/Users/Add";
import AddOrderByOfferPanel from "../Page/Orders/add/AddOrderByOfferPanel";
import AddOrderByServicePanel from "../Page/Orders/add/AddOrderByServicePanel";
import OrdersDetailsPanel from "../Page/Orders/view/OrdersDetailsPanel";
import Reviews from "../Page/Reviews/Reviews";
import Categories from "../Page/Categories";
import AddCategory from "../Page/Categories/Add";
import EditCategory from "../Page/Categories/Edit";
import SubCategories from "../Page/SubCategories";
import AddSubCategory from "../Page/SubCategories/Add";
import EditSubCategory from "../Page/SubCategories/Edit";
import Faqs from "../Page/Faqs";
import AddFaq from "../Page/Faqs/Add";
import EditFaq from "../Page/Faqs/Edit";
import SettingsPage from "../Page/Settings";
import PanelsLog from "../Page/Panels/Log";
import Marketers from "../Page/Marketers";
import AddMarketer from "../Page/Marketers/Add";
import EditMarketer from "../Page/Marketers/Edit";
import UpdatedPanelsTable from "../UI/Panels/UpdatedPanels/UpdatedPanelsTable";
import PanelsByTypeTable from "../UI/Panels/PanelsByType/PanelsByTypeTable";

const rootReducer = combineReducers({
  Sidebar: SidebarReducer,
  Alert: AlertReducer,
  Branch: BranchReducer,
  Delete: DeleteReducer,
  Modal: ModalReducer,
});
const store = createStore(rootReducer);
const DashboardLayout = (props) => {
  return (
    <div className="overflow-x-hidden">
      <Provider store={store}>
        <Head toggleTheme={props.toggleTheme} thememode={props.thememode} />
        <Sidebar thememode={props.thememode} />
        <Alert />
        {props.content === "Dashboard" && <Container content={<Dashboard />} />}
        {props.content === "Support" && <Container content={<Support />} />}
        {props.content === "Support-Chat" && (
          <Container content={<SupportChat />} />
        )}
        {props.content === "TelegramGroups" && (
          <Container content={<TelegramGroup />} />
        )}
        {props.content === "AddTelegramGroups" && (
          <Container content={<AddTelegramGroup />} />
        )}
        {props.content === "EditTelegramGroups" && (
          <Container content={<EditTelegramGroup />} />
        )}
        {props.content === "SkypeGroups" && (
          <Container content={<SkypeGroup />} />
        )}
        {props.content === "AddSkypeGroups" && (
          <Container content={<AddSkypeGroup />} />
        )}
        {props.content === "EditSkypeGroups" && (
          <Container content={<EditSkypeGroup />} />
        )}
        {props.content === "WhatsappGroups" && (
          <Container content={<WhatsappGroups />} />
        )}
        {props.content === "AddWhatsappGroups" && (
          <Container content={<AddWhatsappGroup />} />
        )}
        {props.content === "EditWhatsappGroups" && (
          <Container content={<EditWhatsappGroup />} />
        )}
        {props.content === "Offers" && <Container content={<Offers />} />}
        {props.content === "Add-Offer" && <Container content={<OfferAdd />} />}
        {props.content === "Edit-Offer" && (
          <Container content={<OfferEdit />} />
        )}
        {props.content === "Shop-ADS" && (
          <Container content={<ShopADSView />} />
        )}
        {props.content === "Add-AD" && <Container content={<ShopAdsAdd />} />}
        {props.content === "Edit-AD" && <Container content={<ShopAdsEdit />} />}
        {props.content === "Ads-Pin" && <Container content={<PinPanel />} />}
        {props.content === "Edit-Ads-Pin" && (
          <Container content={<EditPinPanel />} />
        )}
        {props.content === "Ads-Ticket" && (
          <Container content={<TicketPanel />} />
        )}
        {props.content === "Edit-Ads-Ticket" && (
          <Container content={<EditTicketPanel />} />
        )}
        {props.content === "Ads-Main-Page" && (
          <Container content={<BannerPanel />} />
        )}
        {props.content === "Edit-Ads-Main-Page" && (
          <Container content={<EditBannerPanel />} />
        )}
        {props.content === "Ads-Search-Result" && (
          <Container content={<TopResultPanel />} />
        )}
        {props.content === "Orders" && <Container content={<OrdersPanel />} />}
        {props.content === "Order-Details" && (
          <Container content={<OrdersDetailsPanel />} />
        )}
        {props.content === "Add-Order-By-Service" && (
          <Container content={<AddOrderByServicePanel />} />
        )}
        {props.content === "Add-Order-By-Offer" && (
          <Container content={<AddOrderByOfferPanel />} />
        )}
        {props.content === "Users" && <Container content={<UsersPanel />} />}
        {props.content === "Add-Users" && <Container content={<AddUser />} />}
        {props.content === "User-Details" && (
          <Container content={<UserDetails />} />
        )}
        {props.content === "User-Edit" && <Container content={<EditUser />} />}
        {props.content === "Employees" && (
          <Container content={<EmployeesPanel />} />
        )}
        {props.content === "Add-Employee" && (
          <Container content={<AddEmployee />} />
        )}
        {props.content === "Edit-Employee" && (
          <Container content={<EditEmployee />} />
        )}
        {props.content === "Panels" && <Container content={<Panels />} />}
        {props.content === "Add-Panel" && <Container content={<AddPanel />} />}
        {props.content === "Edit-Panel" && (
          <Container content={<EditPanel />} />
        )}
        {props.content === "View-Panel" && (
          <Container content={<ViewPanel />} />
        )}
        {props.content === "View-Trusted-Panel" && (
          <Container content={<TrustedPanels />} />
        )}
        {props.content === "View-Panels-Log" && (
          <Container content={<PanelsLog />} />
        )}
        {props.content === "View-UpdatedPanels" && (
          <Container content={<UpdatedPanelsTable />} />
        )}
        {props.content === "View-PanelsByType" && (
          <Container content={<PanelsByTypeTable />} />
        )}
        {props.content === "Categories" && (
          <Container content={<Categories />} />
        )}
        {props.content === "Add-Category" && (
          <Container content={<AddCategory />} />
        )}
        {props.content === "Edit-Category" && (
          <Container content={<EditCategory />} />
        )}
        {props.content === "SubCategories" && (
          <Container content={<SubCategories />} />
        )}
        {props.content === "Add-SubCategory" && (
          <Container content={<AddSubCategory />} />
        )}
        {props.content === "Edit-SubCategory" && (
          <Container content={<EditSubCategory />} />
        )}
        {props.content === "Faqs" && <Container content={<Faqs />} />}
        {props.content === "Add-Faqs" && <Container content={<AddFaq />} />}
        {props.content === "Edit-Faqs" && <Container content={<EditFaq />} />}

        {props.content === "Marketers" && <Container content={<Marketers />} />}
        {props.content === "Add-Marketers" && (
          <Container content={<AddMarketer />} />
        )}
        {props.content === "Edit-Marketers" && (
          <Container content={<EditMarketer />} />
        )}
        {props.content === "Settings" && (
          <Container content={<SettingsPage />} />
        )}
        {props.content === "Reviews" && <Container content={<Reviews />} />}
      </Provider>
    </div>
  );
};

export default DashboardLayout;
